import { useState, useEffect } from 'react';
import Layout from './components/Layout';
import Dashboard from './views/Dashboard';
import { NeedReport, NeedReview, JdLibrary, ChannelPlan, Budget } from './views/Stage1';
import { ChannelOps, ResumeScreen, TalentPool } from './views/Stage2';
import { Invite, InterviewArrange, InterviewEval, Assessment, InterviewResult } from './views/Stage3';
import { SalaryApproval, BgCheck, OfferSend } from './views/Stage4';
import { PreOnboard, Onboard, OnboardGuide } from './views/Stage5';
import { ProbationTrack, Regularization, Analytics, Optimize } from './views/Stage6';
import { TOP_NAV } from './config';

export default function App() {
  // 当前视图：'dashboard' 或某个 module id
  const [currentView, setCurrentView] = useState<string>('dashboard');
  const [currentModule, setCurrentModule] = useState<string>('');

  // 路由：view 决定顶栏高亮，module 决定侧边栏高亮和主体内容
  const navigate = (view: string) => {
    setCurrentView(view);
    if (view === 'dashboard') {
      setCurrentModule('');
    } else {
      const module = TOP_NAV[view];
      setCurrentModule(module);
    }
    // 滚动到顶部
    document.getElementById('main-content')?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openModule = (module: string) => {
    setCurrentModule(module);
    setCurrentView(''); // 顶栏不高亮
    // 找到对应的顶栏视图用于返回
    const topView = Object.entries(TOP_NAV).find(([_, m]) => m === module)?.[0];
    if (topView) setCurrentView(topView);
    document.getElementById('main-content')?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 渲染主体
  const renderContent = () => {
    if (currentView === 'dashboard' && !currentModule) {
      return <Dashboard onOpenModule={openModule} />;
    }
    switch (currentModule) {
      case 'need-report':       return <NeedReport />;
      case 'need-review':       return <NeedReview />;
      case 'jd-library':        return <JdLibrary />;
      case 'channel-plan':      return <ChannelPlan />;
      case 'budget':            return <Budget />;
      case 'channel-ops':       return <ChannelOps />;
      case 'resume-screen':     return <ResumeScreen />;
      case 'talent-pool':       return <TalentPool />;
      case 'invite':            return <Invite />;
      case 'interview-arrange': return <InterviewArrange />;
      case 'interview-eval':    return <InterviewEval />;
      case 'assessment':        return <Assessment />;
      case 'interview-result':  return <InterviewResult />;
      case 'salary-approval':   return <SalaryApproval />;
      case 'bg-check':          return <BgCheck />;
      case 'offer-send':        return <OfferSend />;
      case 'pre-onboard':       return <PreOnboard />;
      case 'onboard':           return <Onboard />;
      case 'onboard-guide':     return <OnboardGuide />;
      case 'probation-track':   return <ProbationTrack />;
      case 'regularization':    return <Regularization />;
      case 'analytics':         return <Analytics />;
      case 'optimize':          return <Optimize />;
      default:                  return <Dashboard onOpenModule={openModule} />;
    }
  };

  return (
    <Layout
      currentView={currentView}
      currentModule={currentModule}
      onNavigate={navigate}
      onOpenModule={openModule}
    >
      {renderContent()}
    </Layout>
  );
}
